// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  margin: 1rem;
  background: #6c757d;
  text-transform: uppercase;
}
.btn small {
  text-transform: none;
  opacity: 0.7;
}

.card {
  border: 0;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
.card .card-body:empty {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dev-navigation/dev-navigation.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;AACJ;AACI;EACI,oBAAA;EACA,YAAA;AACR;;AAIA;EACI,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAGI;EACI,UAAA;AADR","sourcesContent":[".btn {\n    margin: 1rem;\n    background: #6c757d;\n    text-transform: uppercase;\n\n    small {\n        text-transform: none;\n        opacity: .7;\n    }\n\n}\n\n.card {\n    border: 0;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n\n    .card-body:empty {\n        padding: 0\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
